import React from 'react'
import ProcessingIdAnimationBackground from "../../assets/images/ProcessingIdAnimationBackground.png";
import ProcessingIdAnimationImg1 from "../../assets/images/ProcessingIdAnimationImg1.png";
import Rotator from './Rotator';

const ProcessLoader = () => {
    return (
        <div className="mt-4 h-80 relative items-center">
            <figure className="absolute z-10">
                <img alt="icon" className="w-full" src={ProcessingIdAnimationBackground} />
            </figure>
            <figure className="absolute z-20">
                <img alt="icon" className="w-full mx-3 mt-1" src={ProcessingIdAnimationImg1} />
            </figure>
            <Rotator />
        </div>
    )
}

export default ProcessLoader